import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import ContentList from 'components/ContentList';
import PodcastPlayer from '../PodcastPlayer';

import styles from './styles.module.scss';

export const PlaylistContainer = ({ trackList = [] }) => {
	const [previousTrack, setPreviousTrack] = useState(null);
	const [currentTrack, setCurrentTrack] = useState(trackList[0]);

	const playerRef = useRef(null);

	const isPlayingNewTrack =
		previousTrack !== null && currentTrack?.src !== previousTrack?.src;

	useEffect(() => {
		setCurrentTrack(trackList[0]);
	}, [trackList.length]);

	const playNewTrackFromList = (id) => {
		const foundTrack = trackList.find((track) => track?._id === id);
		setPreviousTrack(currentTrack);
		setCurrentTrack(foundTrack);
		playerRef?.current?.focus();
	};

	if (trackList.length === 1) {
		return <PodcastPlayer track={currentTrack} />;
	}

	return (
		<div className={styles.PlaylistContainer}>
			<PodcastPlayer
				track={currentTrack}
				autoPlay={isPlayingNewTrack}
				ref={playerRef}
			/>
			<ContentList
				items={trackList.map((track) => ({
					...track,
					onClick: () => playNewTrackFromList(track?._id),
					key: track._id
				}))}
				itemsScrollLimit={10}
				activeKey={currentTrack._id}
			/>
		</div>
	);
};

PlaylistContainer.propTypes = {
	trackList: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string,
			title: PropTypes.string,
			key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			widgetId: PropTypes.number
		})
	).isRequired
};
